import { MessageIcon, HeartIcon, UsersIcon, BookOpenIcon, ArrowRightIcon } from "./icons";
import { GlassCard } from "./ui";

/** "**texto**" → negrito, sem interpretar HTML (o texto vem do painel). */
function renderBold(text) {
  return String(text || "")
    .split(/\*\*(.+?)\*\*/g)
    .map((part, i) => (i % 2 ? <strong key={i}>{part}</strong> : part));
}

export function hasAboutContent(about) {
  return Boolean(about && (String(about.title || "").trim() || (about.paragraphs || []).some((p) => String(p || "").trim())));
}

export const AboutChurchSection = ({ about, whatsapp, onNav }) => {
  if (!hasAboutContent(about)) return null;
  const paragraphs = (about.paragraphs || []).filter((p) => String(p || "").trim());
  return (
  <section id="sobre" className="public-section public-about-section py-10 sm:py-14 scroll-mt-20">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid gap-6 lg:grid-cols-[1.08fr_.92fr] items-stretch">
        <GlassCard className="relative overflow-hidden p-6 sm:p-8 !bg-slate-950 !text-white border-slate-900 shadow-[0_22px_50px_rgba(15,23,42,0.18)]">
          <div className="absolute -right-16 -top-20 h-56 w-56 rounded-full bg-indigo-500/25 blur-3xl" aria-hidden="true" />
          <div className="relative">
            <p className="text-xs sm:text-sm uppercase tracking-[0.18em] text-indigo-200 font-bold">Quem somos</p>
            {about.title ? (
              <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight leading-tight !text-white">
                {about.title}
              </h2>
            ) : null}
            {paragraphs.map((text, idx) => (
              <p
                key={idx}
                className={`${idx === 0 ? "mt-4" : "mt-3"} max-w-2xl !text-slate-200 dark:text-slate-700 leading-relaxed`}
              >
                {renderBold(text)}
              </p>
            ))}
            {about.closing ? (
              <p className="mt-4 max-w-2xl font-bold !text-white leading-relaxed">{renderBold(about.closing)}</p>
            ) : null}
            <div className="mt-7 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={() => onNav("#cultos")}
                className="inline-flex items-center gap-2 rounded-full bg-white dark:bg-slate-900 px-4 py-2.5 text-sm font-bold text-slate-950 dark:text-slate-50 hover:bg-indigo-50 dark:hover:bg-indigo-950/40 transition"
              >
                Ver a nossa agenda <ArrowRightIcon />
              </button>
              {whatsapp ? (
                <a
                  href={whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-2.5 text-sm font-bold !text-white hover:bg-white/20 transition"
                >
                  Pedir oração <MessageIcon />
                </a>
              ) : null}
            </div>
          </div>
        </GlassCard>

        <GlassCard className="p-6 sm:p-8 bg-white dark:bg-slate-900/65 border-white dark:border-slate-900/80">
          <p className="text-xs sm:text-sm uppercase tracking-[0.18em] text-indigo-600 dark:text-indigo-300 font-bold">A nossa identidade</p>
          <h3 className="mt-2 text-2xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">Firmes na fé, próximos das pessoas.</h3>
          <div className="mt-6 grid gap-3">
            {[
              { icon: BookOpenIcon, title: "Palavra", text: "Aprendemos e praticamos o evangelho no dia a dia." },
              { icon: UsersIcon, title: "Comunhão", text: "Caminhamos juntos como uma família espiritual." },
              { icon: HeartIcon, title: "Missão", text: "Servimos a igreja, as famílias e a nossa comunidade." },
            ].map((item) => {
              const Icon = item.icon;
              return (
                <div key={item.title} className="flex items-start gap-3 rounded-2xl border border-indigo-100 dark:border-indigo-900/50 bg-indigo-50/55 dark:bg-indigo-950/40 p-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white dark:bg-slate-900 text-indigo-700 dark:text-indigo-300 shadow-sm">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 dark:text-slate-100">{item.title}</div>
                    <p className="mt-0.5 text-sm leading-relaxed text-slate-600 dark:text-slate-400">{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </GlassCard>
      </div>
    </div>
  </section>
  );
};
